import querystring from 'querystring'
import axios from 'axios'
import $ from 'jquery'
import Cookies from 'js-cookie'
import { getSite } from '@/utils/site'
import { SLD } from '@/utils/INTERFACE'

export default {
	async get(url, data) {
		var site=getSite()
		Cookies.set('site', site, { domain: SLD().cookieBase })
		var res = await axios.get(url, { params: data })
		if (!res.data) throw new Error("No data")
		if (res.data.result === false) {
			var err = new Error(res.data.message)
			if (res.data.messages) err.messages = res.data.messages
			throw err
		}
		return res.data
	},
	async post(url, data) {
		var res = await axios.post(url, querystring.stringify(data), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'csrf-token': $('#csrf-token').length > 0 && $('#csrf-token').val() || ''
			}
		})
		if (res.data['csrf-token']) {
			$('#csrf-token').val(res.data['csrf-token']);
		}
		if (!res.data) throw new Error("No data")
		if (res.data.result === false) {
			var err = new Error(res.data.message)
			if (res.data.messages) err.messages = res.data.messages
			throw err
		}
		return res.data
	},
	jsonp: {
		get(url, data) {
			return new Promise((resolve, reject) => {
				$.ajax({ type: "get", dataType: "jsonp", url, data, success: resolve, error: (XMLHttpRequest, textStatus, errorThrown) => reject(textStatus) })
			})
		}
	}
}
